// Interface

import util from '@/utils/classToObject'
import { IAdminFleetState } from './state'
import { AloDbFleet, isAloDbFleetFree } from '@/models/alodb/AloDbFleet'
import { toNumberLookup, toNumberDictionary } from '@/utils/groupBy'
import { AloDbFleetConfig } from '@/models/alodb/AloDbFleetConfig'
import { AloMission } from '@/models/alo/AloMission'

const filterOnGoingPredicate = (fleet: AloDbFleet, missionsById: Record<number, AloMission>, ongoing: boolean) =>
  (((fleet?.param?.missionIds?.length ?? 0) == 0 && !isAloDbFleetFree(fleet)) ||
    (fleet.param.missionIds?.some(misId => missionsById[misId]?.misActifOn) ?? false)) == ongoing
const filterEnseignePredicate = (fleet: AloDbFleet, ensIds: Array<number>) =>
  ensIds.length == 0 || ensIds.indexOf(fleet.ENS_ID!) > -1

export class AdminFleetGetter {
  public adminFleets(state: IAdminFleetState, getters: any) {
    return state.adminFleetsId.map(id => state.adminFleetsById[id])
  }

  // BLF037 — flottes que les vues montrent : enseigne avec la Gestion de flotte et le type
  // (RG-ACC-050). `adminFleets` / `adminFleetsById` restent bruts (chargement, accès par id).
  public allowedAdminFleets(state: IAdminFleetState, getters: any) {
    return (getters.adminFleets as Array<AloDbFleet>).filter(fleet => getters.isFleetAllowed(fleet))
  }

  public isFleetOnGoing(state: IAdminFleetState, getters: any) {
    return (fleet: AloDbFleet) => filterOnGoingPredicate(fleet, getters.missionsById, true)
  }

  public filteredFleet(state: IAdminFleetState, getters: any, rootState: any, rootGetters: any) {
    return (getters.allowedAdminFleets as Array<AloDbFleet>).filter(
      m =>
        filterOnGoingPredicate(m, rootGetters.missionsById, rootState.ui.ongoingMissionActive) &&
        filterEnseignePredicate(m, rootState.mission.filterMission.ensIds),
    )
  }

  public adminFleetsById(state: IAdminFleetState) {
    return state.adminFleetsById
  }

  public modifiedAdmAdminFleet(state: IAdminFleetState, getters: any) {
    return state.modifiedAdmAdminFleet
  }

  public originalAdmAdminFleet(state: IAdminFleetState, getters: any) {
    return state.originalAdmAdminFleet
  }

  public adminFleetLoading(state: IAdminFleetState, getters: any) {
    return state.adminFleetLoading
  }

  public adminFleetStatus(state: IAdminFleetState) {
    return state.status
  }

  public adminAdminFleetFilter(state: IAdminFleetState) {
    return state.adminFilter
  }

  public fleetConfigsByFleet(state: IAdminFleetState) {
    return toNumberLookup(state.configsFleet, c => c.FLE_ID!)
  }

  public fleetConfigsById(state: IAdminFleetState) {
    return toNumberDictionary(state.configsFleet, c => c.FLC_ID!)
  }

  public currentFleetConfig(state: IAdminFleetState) {
    return state.currentConfig
  }

  public histoConfig(state: IAdminFleetState) {
    return state.histoConfig
  }

  public showHistoConfig(state: IAdminFleetState) {
    return state.histoConfig.FLC_ID! > 0
  }
}

export default util.classToObject(AdminFleetGetter)
